import { createAction } from '../../../store.model';
import { ActionType } from '../search.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface LoadMore {}

export const loadMore = createAction<ActionType, LoadMore>(
    ActionType.EVAL_SEARCH__LOAD_MORE,
);
